/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef } from 'react';
import lang from 'common/lang';
import Typography from 'common/designSystem/typography';
import { CgSubscriptionHeaderContainer, CgSubscriptionNumberUrl } from './styles';
import { OrderHeaderProps } from './types';

export const CgSubscriptionHeader = (props: OrderHeaderProps) => {
  const {
    name, createdAt,
  } = props;
  const { order: orderCopy } = lang;
  const authHeaderRef = useRef<HTMLHeadElement | null>(null);
  const orderHeaderRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    authHeaderRef.current = document.querySelector('.auth-header');
    window.addEventListener('scroll', handleOrderHeaderPosition);

    return (() => window.removeEventListener('scroll', handleOrderHeaderPosition));
  }, []);

  const handleOrderHeaderPosition = () => {
    if (authHeaderRef?.current && orderHeaderRef?.current) {
      if (authHeaderRef.current.classList.contains('header-visible')) {
        orderHeaderRef.current.classList.add('header-exists');
        return;
      }
      orderHeaderRef.current.classList.remove('header-exists');
    }
  };

  return (
    <CgSubscriptionHeaderContainer className="order-header" ref={orderHeaderRef}>
      <CgSubscriptionNumberUrl>
        <Typography variant="heading-compact-02">
          {`${orderCopy.planNumber} #${name}`}
        </Typography>
      </CgSubscriptionNumberUrl>
      <Typography variant="heading-compact-02">
        {createdAt}
      </Typography>
    </CgSubscriptionHeaderContainer>
  );
};

export default CgSubscriptionHeader;
